import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../../store/api/authApiSlice";
import {
	clearError,
	selectIsAuthenticated,
	selectAuthError,
} from "../../store/slices/authSlice";
import { PRIVATE_ROUTES } from "../../config";
import { LoginForm } from "./components";
import styles from "./LoginPage.module.css";

const LoginPage = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const authError = useSelector(selectAuthError);

	const [login, { isLoading }] = useLoginMutation();
	const [error, setError] = useState("");

	useEffect(() => {
		if (isAuthenticated) {
			navigate(PRIVATE_ROUTES.DASHBOARD);
		}

		dispatch(clearError());
	}, [isAuthenticated, navigate, dispatch]);

	useEffect(() => {
		if (authError) {
			setError(authError);
		}
	}, [authError]);

	const handleLogin = async (credentials) => {
		try {
			setError("");

			await login(credentials).unwrap();

			navigate(PRIVATE_ROUTES.DASHBOARD);
		} catch (err) {
			console.error("Login failed:", err);

			if (err.status === 401) {
				setError("Invalid email or password");
			} else if (err.data?.error) {
				setError(err.data.error);
			} else {
				setError("Login failed. Please try again later.");
			}
		}
	};

	return (
		<div className={styles.loginPage}>
			<div className={styles.loginContainer}>
				<div className={styles.logoContainer}>
					<h1 className={styles.title}>Al-Amel School</h1>
					<p className={styles.subtitle}>Teacher Management System</p>
				</div>

				<LoginForm onSubmit={handleLogin} error={error} isLoading={isLoading} />

				<div className={styles.footer}>
					<p>
						© {new Date().getFullYear()} Al-Amel School. All rights reserved.
					</p>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;
